// extracted by mini-css-extract-plugin
export default {"formWrapper":"wrapper_formWrapper__fQc-p","illustrationWrapper":"wrapper_illustrationWrapper__XMJcy","illustration":"wrapper_illustration__9HW4+"};